var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"root-action-icon",class:{
    'theme-purple': _vm.theme === 'purple',
    'theme-green': _vm.theme === 'green',
    'theme-red': _vm.theme === 'red',
    'theme-dark': _vm.theme === 'dark',
    'theme-light': _vm.theme === 'light'
  },attrs:{"href":_vm.href,"disabled":_vm.disabled},on:{"click":function (e) { return !_vm.disabled && _vm.$emit('click', e); }}},[_c('div',{staticClass:"action-icon"},[_c('svgicon',{staticClass:"icon left",attrs:{"name":_vm.icon,"width":_vm.size,"height":_vm.size}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }